import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19.365",
  height: "15.215"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "data-name": "Path 8123",
  d: "M17.837 7.851a3.412 3.412 0 0 0-4.347-4.218 5.529 5.529 0 0 0-10.723 1.9c0 .156.011.309.023.461a4.838 4.838 0 0 0 2.051 9.221h10.374a4.149 4.149 0 0 0 2.622-7.364z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };